export const modalButtonDisplay = {
	BUTTON: "BUTTON",
	INLINE: "INLINE",
};
